import { t } from "i18next";

export const validateEmailDomain = (value: string) => {
  const regexp =
    /^([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])*\.)*[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])*$/;
  return regexp.test(value) ? true : t(`validation.domain.invalid`);
};
